/**
 * Policy status visual mappings.
 * Uses design-system tonal colors instead of MUI default chip colors.
 */

/** Tonal chip styles per status — { bgcolor, color } */
export const STATUS_CHIP_STYLES: Record<string, { bgcolor: string; color: string }> = {
  QUOTE_SELECTED: { bgcolor: 'rgba(44, 88, 137, 0.1)', color: '#2C5889' },
  PROPOSAL_CREATED: { bgcolor: 'rgba(21, 24, 58, 0.08)', color: '#15183A' },
  PAYMENT_PENDING: { bgcolor: 'rgba(21, 24, 58, 0.06)', color: '#15183A' },
  PAYMENT_COMPLETED: { bgcolor: 'rgba(37, 97, 111, 0.1)', color: '#25616F' },
  EMITTED: { bgcolor: 'rgba(37, 97, 111, 0.1)', color: '#25616F' },
  ACTIVE: { bgcolor: 'rgba(44, 88, 137, 0.1)', color: '#2C5889' },
  PENDING_EMISSION: { bgcolor: 'rgba(21, 24, 58, 0.06)', color: '#15183A' },
  PAYMENT_FAILED: { bgcolor: 'rgba(231, 35, 59, 0.08)', color: '#C62828' },
  CANCELLED: { bgcolor: 'rgba(231, 35, 59, 0.08)', color: '#C62828' },
  EXPIRED: { bgcolor: 'rgba(21, 24, 58, 0.05)', color: 'rgba(21, 24, 58, 0.45)' },
};

export const STATUS_LABELS: Record<string, string> = {
  QUOTE_SELECTED: 'Cotización seleccionada',
  PROPOSAL_CREATED: 'Propuesta creada',
  PAYMENT_PENDING: 'Pago pendiente',
  PAYMENT_COMPLETED: 'Pago completado',
  EMITTED: 'Emitida',
  ACTIVE: 'Activa',
  PENDING_EMISSION: 'Pendiente de emisión',
  PAYMENT_FAILED: 'Pago fallido',
  CANCELLED: 'Cancelada',
  EXPIRED: 'Expirada',
};

export const PLAN_NAME_COLORS = [
  '#15183A',
  '#25616F',
  '#2C5889',
  '#F9D00A',
  '#47BCD8',
  '#6293C8',
  '#2A578B',
  '#9EDDFF',
];
